import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    category: [],
    featuredVideo: [],
    allContest: [],
    countryWiseContest: [],
    categoryCountryList: [],
    dailyContestWinner: { list: [] },
    dataLoaded: false,
    homeLoader: true,
    hasMoreFeaturedVideo: true,
    myActivity: {},
    myActivityIndex: 0,
    monthlyActiveVoters: { list: [] },
    myActivityLoader: true,
    filterChange: false,
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_HOME_DATA_SUCCESS:
            return {
                ...state,
                category: action.payload.category,
                featuredVideo: action.payload.featuredVideo,
                allContest: action.payload.allContest,
                countryWiseContest: action.payload.countryWiseContest.filter(data => data._id != null),
                dailyContestWinner: action.payload.dailyContestWinner,
                categoryCountryList: action.payload.categoryCountryList,
                homeLoader: false,
                filterChange: false,
            }
        case actions.FILTER_LIST_DATA: {
            return {
                ...state,
                filterChange: true,
            }
        }
        case actions.GET_CONTEST_HOME_PAGE_DATA_SUCCESS:
            // const { name } = action.payload;
            return {
                ...state,
                category: action.payload.category
            }
        case actions.GET_FEATURE_VIDEO_SUCCESS:
            localStorage.setItem("loadMoreFeaturedVideo", false);
            return {
                ...state,
                featuredVideo: action.payload.newData ? [...action.payload.featuredVideo] : [...state.featuredVideo, ...action.payload.featuredVideo],
                hasMoreFeaturedVideo: action.payload.featuredVideo.length >= 5
            }
        case actions.GET_CONTEST_DATA_SUCCESS:
            return {
                ...state,
                allContest: action.payload.allContest
            }
        case actions.GET_COUNTRY_WISE_CONTEST_DATA_SUCCESS:
            return {
                ...state,
                countryWiseContest: action.payload.countryWiseContest
            }
        case actions.GET_DAILY_CONTEST_WINNER_SUCCESS:
            return {
                ...state,
                dailyContestWinner: action.payload.dailyContestWinner
            }
        case actions.HOME_DATA_LOADED:
            return {
                ...state,
                dataLoaded: true,
            }
        case actions.GET_MY_ACTIVITY_SUCCESS:
            return {
                ...state,
                myActivity: action.payload.myActivity,
                myActivityIndex: action.payload.myActivityIndex,
                myActivityLoader: false
            }
        case actions.SET_MY_ACTIVITY_LOADER:
            return {
                ...state,
                monthlyActiveVoters: "",
                myActivityLoader: true
            }
        case actions.GET_MONTHLY_ACTIVE_VOTERS_SUCCESS:
            return {
                ...state,
                monthlyActiveVoters: action.payload,
                myActivityLoader: false
            }
        case actions.SEND_CONTEST_LIKE_FEATURED_VIDEO_FEEDBACK_SUCCESS:
            const { index, interactionType, from, } = action.payload;
            const { featuredVideo } = state;
            if (interactionType == "B")
                featuredVideo[index].metadata.medias.isBookmarkedFlag = !featuredVideo[index].metadata.medias.isBookmarkedFlag;
            else if (interactionType == "L")
                featuredVideo[index].metadata.medias.isLikedFlag = !featuredVideo[index].metadata.medias.isLikedFlag;
            else if (interactionType == "D")
                featuredVideo.splice(index, 1);
            return {
                ...state,
                featuredVideo: [...featuredVideo]
            }
        case actions.GIVE_VOTE_SUCCESS_FEATURE_VIDEO: {
            const { featuredVideo } = state;
            featuredVideo[action.payload].totalVotes += 1;
            featuredVideo[action.payload].todaysVotes += 1;
            featuredVideo[action.payload].votesByMe += 1;
            featuredVideo[action.payload].isVotedByMe = true;
        }
        case actions.UPDATE_MEDIA_VIEW_COUNT_FEATURED_VIDEOS_SUCCESS: {
            let newFeaturedVideo = state.featuredVideo.map((item, index) => {
                if (index === action.payload.index) {
                    return {
                        ...item,
                        metadata: {
                            ...item.metadata,
                            medias: {
                                ...item.metadata.medias,
                                viewCount: item.metadata.medias.viewCount + 1
                            }
                        }
                    }
                }
                return item;
            });
            return {
                ...state,
                featuredVideo: newFeaturedVideo
            }
        }
        case actions.HOME_ERROR: {
            return {
                ...state,
                homeLoader: false
            }  
        }
        default:
            return state;
    }
};
